var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.options, function (item, index) {
        return [
          _vm.values.includes(item.value)
            ? [
                item.raw.listClass == "default" || item.raw.listClass == ""
                  ? _c(
                      "span",
                      { class: item.raw.cssClass, attrs: { index: index } },
                      [_vm._v(_vm._s(item.label))]
                    )
                  : _c(
                      "a-tag",
                      {
                        class: item.raw.cssClass,
                        attrs: {
                          index: index,
                          color:
                            item.raw.listClass == "grey"
                              ? ""
                              : item.raw.listClass,
                        },
                      },
                      [_vm._v(_vm._s(item.label))]
                    ),
              ]
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }